import api from "../lib/api";

function trackAffiliateClick(url, product) {
  if (!url.includes("amazon.com")) return;
  const slug = window.location.pathname.startsWith("/article/") ? window.location.pathname.split("/article/")[1] : "";
  api.post("/track/click", { url, product, article_slug: slug }).catch(() => {});
}

function renderInline(text) {
  const parts = [];
  let last = 0;
  let k = 0;
  let m;
  const re = /(\*\*([^*]+)\*\*)|(\*([^*]+)\*)|(\[([^\]]+)\]\((https?:\/\/[^)\s]+)\))/g;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    if (m[2] !== undefined) {
      parts.push(<strong key={k++} className="text-porcelain font-semibold">{m[2]}</strong>);
    } else if (m[4] !== undefined) {
      parts.push(<em key={k++} className="font-serif italic">{m[4]}</em>);
    } else if (m[6] !== undefined) {
      parts.push(
        <a key={k++} href={m[7]} target="_blank" rel="noopener noreferrer sponsored"
          onClick={() => trackAffiliateClick(m[7], m[6])}
          className="text-kinetic underline underline-offset-4 decoration-kinetic/40 hover:decoration-kinetic transition-colors">
          {m[6]}
        </a>
      );
    }
    last = re.lastIndex;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

export default function RichText({ body, className = "text-lg" }) {
  const blocks = body.split(/\n\n+/).filter(Boolean);
  return (
    <div data-testid="rich-text-body" className={`${className} leading-relaxed text-porcelain/85 space-y-7`}>
      {blocks.map((b, i) => {
        const img = b.match(/^!\[(.*?)\]\((.*?)\)$/s);
        if (img) {
          return (
            <figure key={i} className="my-10 border border-white/10 overflow-hidden">
              <img src={img[2]} alt={img[1]} className="w-full object-cover" loading="lazy" />
              {img[1] && (
                <figcaption className="text-[11px] font-mono text-ash uppercase tracking-[0.15em] px-4 py-3 bg-surface">{img[1]}</figcaption>
              )}
            </figure>
          );
        }
        if (b.startsWith("> ")) {
          return (
            <blockquote key={i} className="border-l-4 border-kinetic pl-6 py-2 my-10">
              <p className="font-serif italic text-xl lg:text-2xl text-porcelain leading-snug">{renderInline(b.slice(2))}</p>
            </blockquote>
          );
        }
        if (b.startsWith("## ")) {
          return (
            <h2 key={i} className="font-display font-extrabold uppercase text-2xl lg:text-3xl tracking-tight text-porcelain pt-6">
              {renderInline(b.slice(3))}
            </h2>
          );
        }
        return (
          <p key={i} className={i === 0 ? "first-letter:font-display first-letter:font-black first-letter:text-kinetic first-letter:text-6xl first-letter:float-left first-letter:mr-3 first-letter:leading-[0.85]" : ""}>
            {renderInline(b)}
          </p>
        );
      })}
    </div>
  );
}
